// extracted by mini-css-extract-plugin
export var body = "_2f-8";
export var button = "_2f-0";
export var closeButton = "_2f-5";
export var content = "_2f-3";
export var empty = "_2f-f";
export var grid = "_2f-c";
export var header = "_2f-4";
export var icon = "_2f-1";
export var option = "_2f-d";
export var optionSelected = "_2f-e";
export var overlay = "_2f-2";
export var searchIcon = "_2f-a";
export var searchInput = "_2f-b";
export var searchWrapper = "_2f-9";
export var title = "_2f-6";
export var visuallyHidden = "_2f-7";